module.exports = __webpack_public_path__ + "img/sidebar-bg.073e4461.svg";